var _circle, _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 227,
    viewBox: "0 0 227 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 99.5391,
    r: 48.5943,
    fill: "#F1F1F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94.4365,
    y: 98.5487,
    width: 47.5749,
    height: 66.6048,
    rx: 4.75748,
    transform: "rotate(2.5 94.4365 98.5487)",
    fill: "#EEEEEE",
    stroke: "#999999",
    strokeWidth: 1.35928
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.1535,
    y: 94.5647,
    width: 50.2934,
    height: 69.3234,
    rx: 6.11677,
    transform: "rotate(-7.5 66.1535 94.5647)",
    fill: "#FAFAFA",
    stroke: "#999999",
    strokeWidth: 1.35928
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.6257 100.54C67.2338 97.5632 69.3295 94.832 72.3066 94.4401L110.041 89.4723C113.018 89.0803 115.749 91.1761 116.141 94.1532L117.472 104.261L68.9564 110.648L67.6257 100.54Z",
    fill: "#EEEEEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 125.982,
    y: 90.801,
    width: 2.03892,
    height: 6.79641,
    rx: 1.01946,
    transform: "rotate(82.5 125.982 90.801)",
    fill: "#999999"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 107.363,
    y: 79.5422,
    width: 2.03892,
    height: 6.79641,
    rx: 1.01946,
    transform: "rotate(-7.5 107.363 79.5422)",
    fill: "#999999"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 119.309,
    y: 81.397,
    width: 2.03892,
    height: 6.79641,
    rx: 1.01946,
    transform: "rotate(37.5 119.309 81.397)",
    fill: "#999999"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 74.028,
    y: 112.722,
    width: 39.4192,
    height: 2.71856,
    rx: 1.35928,
    transform: "rotate(-7.5 74.028 112.722)",
    fill: "#DCDCDC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 75.8021,
    y: 126.199,
    width: 39.4192,
    height: 2.71856,
    rx: 1.35928,
    transform: "rotate(-7.5 75.8021 126.199)",
    fill: "#DCDCDC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5764,
    y: 139.675,
    width: 39.4192,
    height: 2.71856,
    rx: 1.35928,
    transform: "rotate(-7.5 77.5764 139.675)",
    fill: "#DCDCDC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7377,
    y: 118.113,
    width: 14.2725,
    height: 2.71856,
    rx: 1.35928,
    transform: "rotate(-7.5 74.7377 118.113)",
    fill: "#EEEEEE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5118,
    y: 131.589,
    width: 14.2725,
    height: 2.71856,
    rx: 1.35928,
    transform: "rotate(-7.5 76.5118 131.589)",
    fill: "#EEEEEE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 78.2861,
    y: 145.066,
    width: 14.2725,
    height: 2.71856,
    rx: 1.35928,
    transform: "rotate(-7.5 78.2861 145.066)",
    fill: "#EEEEEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.704f8b3b765d8caea49b534489c71409.svg";
export { ForwardRef as ReactComponent };